jQuery(function($)
{
    let $toCartBtn = $('button.toCart');
    var $quantityMultiply = $('.js-product-quantity .js-quantity-count');
    var $quantityButton = $('.js-product-quantity .quantity-button');

    var $realQuantityPerPackage = $('.real-quantity-per-package').text();
    var $realQuantityOutput = $('.real-quantity');

    function quantityCalculator($currentQuantity)
    {
        var realQuantity = $currentQuantity * parseInt($realQuantityPerPackage);

        $realQuantityOutput.text('= ' + realQuantity);
    }

    $quantityMultiply.on('submit change keyup', function()
    {
        quantityCalculator($(this).val());
    });

    $quantityButton.on('click', function(event)
    {
        if ($(event.target).hasClass('js-quantity-count-up'))
        {
            quantityCalculator(parseInt($quantityMultiply.val()) + 1);
        }
        else if ($(event.target).hasClass('js-quantity-count-down') && parseInt($quantityMultiply.val()) > 0)
        {
            quantityCalculator(parseInt($quantityMultiply.val()) - 1);
        }
    });

    $toCartBtn.on('click', () =>
    {
        $realQuantityOutput.text('');
    });
});
